import React from "react";
import { useTranslation } from "react-i18next";

export default function Maintenance() {
  const { t } = useTranslation("components");
  return (
    <div className="container-fluid vh-100 d-flex justify-content-center align-items-center bg-light">
      <div className="text-center">
        <h1 className="display-4">🚧 {t("maintenance.title")}</h1>
        <p className="lead mt-3">
          {t("maintenance.underMaintenance")}
        </p>
        <p>{t("maintenance.improvements")}</p>

        <div className="spinner-border text-primary mt-3" role="status">
          <span className="sr-only">{t("maintenance.loading")}</span>
        </div>
      </div>
    </div>
  );
}